module.exports = __webpack_public_path__ + "img/feed-6.7c4fe94c.jpg";